"use strict";
/* eslint-disable no-dupe-keys */
module.exports = {
    invoice: 'Faktura' || 'invoice',
    writeInvoice: 'Skapa order' || 'writeInvoice',
    ensureInvariants: 'Räkna om totaler' || 'ensureInvariants',
    upsert: '' || 'upsert',
    upsertWhenEmpty: '' || 'upsertWhenEmpty',
    updateWhenEmpty: '' || 'updateWhenEmpty',
    update: '' || 'update',
    id: 'Identitet' || 'id',
    invoiceDate: 'Fakturadatum' || 'invoiceDate',
    invoiceNumber: 'Fakturanummer' || 'invoiceNumber',
    invoiceOrigin: 'Fakturaursprung' || 'invoiceOrigin',
    invoiceOrigins: {
        supplier: 'Manuell order' || 'supplier',
        export: 'EMCS-order' || 'export',
        customer: 'Flaivy.com' || 'customer',
        systembolaget: 'Systembolaget' || 'systembolaget',
        internal: 'Intern order' || 'internal',
        whitelabel: 'E-handel' || 'whitelabel',
        purchasing: 'Qvanti' || 'purchasing',
        stockfiller: 'Stockfiller' || 'stockfiller',
        dropshipping: 'Mail-flöde' || 'dropshipping',
        returnToSupplier: 'Utleverans' || 'returnToSupplier',
    },
    cancelled: 'Makulerad' || 'cancelled',
    booked: 'Bokförd' || 'booked',
    credit: 'Kredit' || 'credit',
    currency: 'Valuta' || 'currency',
    customerSubUnit: 'Kund' || 'customerSubUnit',
    organisationNumber: 'OrganisationNumber' || 'organisationNumber',
    OCR: 'OCR' || 'OCR',
    yourOrderNumber: 'YourOrderNumber' || 'yourOrderNumber',
    ourReference: 'Vår referens' || 'ourReference',
    externalInvoiceReference1: 'ExternalInvoiceReference1' || 'externalInvoiceReference1',
    externalInvoiceReference2: 'ExternalInvoiceReference2' || 'externalInvoiceReference2',
    dueDate: 'Förfallodatum' || 'dueDate',
    deliveryDate: 'leveransdatum' || 'deliveryDate',
    creditInvoiceNumberReference: 'Refererande krediterat fakturanummer' || 'creditInvoiceNumberReference',
    invoiceNumberReference: 'Refererande fakturanummer' || 'invoiceNumberReference',
    finalPayDate: 'Betalningsdatum (när betalningen kom in)' || 'finalPayDate',
    remarks: 'remarks' || 'remarks',
    owningSupplierOrganizationId: 'owningSupplierOrganizationId' || 'owningSupplierOrganizationId',
    isPayed: 'Betald' || 'isPayed',
    totalExcludingVAT: 'Fakturavärde' || 'totalExcludingVAT',
    grandTotal: 'Fakturavärde' || 'grandTotal',
    invoiceRows: {
        id: 'Identitet' || 'id',
        article: 'Artikel' || 'article',
        deliveredQuantity: 'DeliveredQuantity' || 'deliveredQuantity',
        name: 'Namn' || 'name',
        discount: 'Discount' || 'discount',
        discountType: 'DiscountType' || 'discountType',
        price: 'pris' || 'price',
        commission: 'Kommissionsmarginal' || 'commission',
        commissionDiscount: 'Procentrabatt p.ga. storköp' || 'commissionDiscount',
        totalExcludingVAT: 'Total (excl moms)' || 'totalExcludingVAT',
        total: 'Total' || 'total',
        totalIncludingRecycle: 'Total ink pant' || 'totalIncludingRecycle',
        totalRecycle: 'pant' || 'totalRecycle',
        comments: 'Kommentar' || 'comments',
        unit: 'Enhet' || 'unit',
        VATPercentage: 'Moms' || 'VATPercentage',
        accountNumber: 'Konto' || 'accountNumber',
    },
};
